<!-- 打印组装单中已经组包好的标签 -->
<template>
  <div class="searchAp-ctn">
    <div class="search-ctn">
      <div class="search-ctn-left">
        <div class="flex">
          <div class="search-name">汽配编码</div>
          <div>
            <el-input
              class="search-item"
              size="small"
              v-model.trim="searchData.APCode"
              placeholder="汽配编码"
            ></el-input>
          </div>
          <div class="search-name">汽配名称</div>
          <el-input
            v-model.trim="searchData.APName"
            class="search-item"
            size="small"
            style="width: 200px"
            placeholder="汽配名称"
          ></el-input>
          <div class="search-name">适用车型</div>
          <el-input
            v-model.trim="searchData.AutoSerise"
            class="search-item"
            size="small"
            style="width: 200px"
            placeholder="适用车型"
          ></el-input>
          <el-button
            size="small"
            icon="el-icon-search"
            class="search-btn btn-primary"
            @click="handleSearch"
            >查询</el-button
          >
          <el-button
            size="small"
            icon="el-icon-refresh"
            class="search-btn btn-primary"
            @click="resetSearch"
            >重置</el-button
          >
          <el-button
            size="small"
            class="search-btn btn-primary"
            v-if="showPrintAllBtn"
            @click="printAllLabel()"
            >全部打印</el-button
          >
        </div>
      </div>
    </div>
    <div>
      <el-table
        :header-cell-style="{ background: '#F2F6FC' }"
        v-loading="loading"
        :data="tableData"
        border
        ref="multipleTable"
        height="500px"
        style="width: 100%; margin-bottom: 10px"
      >
        <el-table-column
          fixed
          show-overflow-tooltip
          width="200"
          prop="APCode"
          label="汽配编码"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          min-width="200"
          prop="GoodName"
          label="配件名称"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          min-width="200"
          prop="AutoSerise"
          label="适用车型"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="60"
          prop="Unit"
          label="单位"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="80"
          prop="Count"
          label="组装数量"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="80"
          prop="PrintCount"
          label="已打印数"
        ></el-table-column>
        <el-table-column show-overflow-tooltip width="110" label="标签打印状态">
          <template slot-scope="scope">
            <span>{{
              scope.row.Count - scope.row.PrintCount == 0
                ? "已打印标签"
                : scope.row.PrintCount == 0
                ? "未打印标签"
                : "已部分打印"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="105">
          <template slot-scope="scope">
            <div class="ops-ctn">
              <el-button
                title="查看标签"
                size="mini"
                type="text"
                @click="showCheckLabelsDialog(scope.row)"
                v-if="scope.row.PrintCount > 0"
                >查看标签</el-button
              >
              <el-button
                title="打印商品标签"
                size="mini"
                type="text"
                @click="printLabel(scope.row)"
                v-if="
                  scope.row.WarehousedCount > scope.row.InLabelCount
                    ? scope.row.Count -
                        scope.row.PrintCount -
                        (scope.row.WarehousedCount - scope.row.InLabelCount) >
                      0
                    : scope.row.Count - scope.row.PrintCount > 0
                "
                >打印</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
        :close-on-click-modal="false"
        title="查看商品标签"
        :visible.sync="showLabelsDialog"
        width="1200px"
        append-to-body
      >
        <div class="dialog-content" v-if="showLabelsDialog">
          <checkGoodsLabels
            @closeDialog="closeCheckLabelsDialog"
            :SetOrderId="setOrderId"
            :EntpGoodsId="entpGoodsId"
          ></checkGoodsLabels>
        </div>
      </el-dialog>
      <el-dialog
        :close-on-click-modal="false"
        title="商品标签打印配置"
        :visible.sync="showPrintSingleLabelsDialog"
        width="600px"
        append-to-body
      >
        <div class="dialog-content" v-if="showPrintSingleLabelsDialog">
          <printSingleLabelSet
            @closeDialog="closePrintSingleLabelsDSialog"
            :SetOrderId="setOrderId"
            :EntpGoodsId="entpGoodsId"
          ></printSingleLabelSet>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import checkGoodsLabels from "@/components/business/goods/checkSetOrderLabels.vue";
import printSingleLabelSet from "@/components/business/goods/printSetOrderSingleLabelSet.vue";
export default {
  name: "",
  props: { SetOrderId: String },
  components: {
    checkGoodsLabels,
    printSingleLabelSet,
  },
  data() {
    return {
      showPrintSingleLabelsDialog: false,
      showLabelsDialog: false,
      loading: false,
      entpGoodsId: "",
      setOrderId: "",
      searchData: {
        SetOrderId: "",
        APName: "",
        APCode: "",
        AutoSerise: "",
      },
      tableData: [],
      showPrintAllBtn:false
    };
  },
  mounted() {
    this.getTableData();
    this.searchData.SetOrderId = this.SetOrderId;
    this.setOrderId = this.SetOrderId;
  },
  methods: {
    resetSearch() {
      this.searchData = {
        SetOrderId: this.SetOrderId,
        APName: "",
        APCode: "",
        AutoSerise: "",
      };
    },
    getTableData() {
      if (this.SetOrderId) {
        this.loading = true;
        this.$util
          .axiosGet({
            url:
              "/api/EntpGoodsLabels/GetPrintEnterpriseSetOrderDetail",
            data: this.searchData,
          })
          .then((res) => {
            let data = res.data;
            if (data) {
              this.tableData = data;
              for (let i = 0; i < data.length; i++) {
              this.showPrintAllBtn= data[i].WarehousedCount > data[i].InLabelCount
                ? data[i].Count - data[i].PrintCount -(data[i].WarehousedCount - data[i].InLabelCount) >0
                : data[i].Count - data[i].PrintCount > 0;
                if(this.showPrintAllBtn)break;
              }
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      } else this.$util.warningMsg("未检测到组装单，请重新操作");
    },
    printLabel(row) {
      let that = this;
      if (row) {
        that.entpGoodsId = row.EntpTempGoodsId;
        that.showPrintSingleLabelsDialog = true;
      } else {
        that.$util.warningMsg("请选择商品进行打印标签");
        return;
      }
    },
    printAllLabel() {
      let that = this;
      that.$util.elConfirm({
        content:
          "谨慎操作！全部打印会默认一个标签码对应一件商品，确定要打印全部商品的标签吗？",
        noMsg: true,
        confirm() {
          //传到接口调用打印出来
          that.$util
            .axiosPost({
              url: "/api/EntpGoodsLabels/PrintSetOrderGoodsLabels",
              data: {
                SetOrderId: that.SetOrderId,
                GoodsId: "",
              },
            })
            .then((res) => {
              if (res.errcode == 0) {
                that.$util.successMsg("提交打印完成");
                that.getTableData();
              } else that.$util.errorMsg(res.errmsg);
            });
        },
      });
    },
    //关闭订单弹出层
    closeCheckLabelsDialog() {
      this.entpGoodsId = "";
      this.showLabelsDialog = false;
    },
    closePrintSingleLabelsDSialog() {
      this.entpGoodsId = "";
      this.showPrintSingleLabelsDialog = false;
      this.getTableData();
    },
    // 打印
    showCheckLabelsDialog(row) {
      if (row) {
        this.entpGoodsId = row.EntpTempGoodsId;
        this.showLabelsDialog = true;
      } else {
        this.$util.warningMsg("请选择商品进行查看");
        return;
      }
    },
    handleSearch() {
      this.searchData.page = 1;
      this.getTableData();
    },
  },
};
</script>
<style lang="less" scoped>
.searchAp-ctn {
  height: 600px;
  overflow-y: auto;
}
</style>